"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function TheCeoProblemCopy() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="the-ceo-problem" className="relative bg-background bg-cover bg-center !bg-[url(https://newmavericks.com/wp-content/uploads/2026/03/ceo_disruption_analytics_bg.webp)] py-20 px-8 min-h-[600px] !bg-[url(https://newmavericks.com/wp-content/uploads/2026/03/city.jpg)] !h-[800px] md:hidden">
      {}
      <div className="absolute inset-0 bg-black/15"></div>
      
      {}
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="flex flex-col items-center justify-center ![margin:30px_0px_0px_0px]">
          {}
          <div ref={textRef} className="flex flex-col items-center text-center gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] lg:order-1 md:hidden" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateX(0)" : "translateX(3rem)"
        }}>
            <h2 className="font-display font-bold text-foreground leading-tight !text-3xl ![margin:-80px_0px_0px_0px]">The CEO Problem</h2>

            <div ref={imageRef} className="transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] lg:order-2 md:hidden w-full flex justify-center" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "translateX(0)" : "translateX(-3rem)"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_cxbahane.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_cxbahane.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_cxbahane.jpg-wvc-sizes" alt="CEO Leadership Challenge" className="w-full max-w-md rounded-lg shadow-medium object-cover h-[350px]" loading="lazy" />
            </div>

            <p className="text-muted-foreground leading-relaxed text-center !text-base !m-0">Data from a 2022 Alix Partners Disruption Index reports 58% of CEOs are replaced within two years of a VC investment &amp; 73% replaced over the lifetime of an investment. <br /><br />In the last couple of years CEOs have been quitting at a record pace indicating many CEOs struggle with having <br />the leadership capacity to protect themselves, performance &amp; progress <br />of their companies.</p>
            <p className="md:hidden text-muted-foreground leading-relaxed text-center !text-base !m-0">CEOs burning out, making a decision they regret, or running so fast they can't actually think is due to the part nobody talks about — the state of consciousness they're making decisions from</p>
            <p className="md:hidden text-muted-foreground leading-relaxed text-center !text-base !m-0"><b>Being clutch under pressure is trainable. We wrote the book on it - The Science of Protection (see below).</b></p>
          </div>

          {}
          
        </div>
      </div>
    </section>;
}